import { cn } from "@design-system/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const captionVariants = cva("text-sm", {
  variants: {
    status: {
      default: "text-foreground-neutral-muted",
      error: "text-foreground-critical-muted",
      warning: "text-foreground-warning-muted",
      success: "text-foreground-success-muted",
    },
  },
  defaultVariants: {
    status: "default",
  },
});

function Caption({
  className,
  status,
  ...props
}: React.ComponentProps<"p"> & VariantProps<typeof captionVariants>) {
  return (
    <p className={cn(captionVariants({ status }), className)} {...props} />
  );
}

export { Caption };
